import { TableCell, Typography } from '@mui/material';
import { getDay, parse } from 'date-fns';
import { FC } from 'react';
import datetimeDecorator from 'src/decorators/datetime.decorator';
import { GridSelection } from 'src/pages/TruckShifts/bulkSelection';

type Props = {
  dateColumns: string[];
  selection?: GridSelection;
};

const weekendColor = (date: string): string | undefined => {
  const day = getDay(parse(date, 'yyyy-MM-dd', new Date()));
  if (day === 0) return '#c62828';
  if (day === 6) return '#1565c0';
  return undefined;
};

export const HeaderCellsPresenter: FC<Props> = ({ dateColumns, selection }) => (
  <>
    {dateColumns.map((date) => {
      const picked = selection?.isDateSelected(date) ?? false;
      return (
        <TableCell
          key={date}
          align="center"
          onClick={selection ? () => selection.toggleDate(date) : undefined}
          sx={{
            width: 156,
            minWidth: 156,
            py: 0.75,
            px: 1,
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.2,
            color: weekendColor(date),
            whiteSpace: 'nowrap',
            borderRight: '1px solid',
            borderColor: 'divider',
            cursor: selection ? 'pointer' : 'default',
            backgroundColor: picked ? '#e3f2fd' : undefined,
            borderTop: picked ? '3px solid #1976d2' : '3px solid transparent',
          }}
        >
          {datetimeDecorator.toDayAndDayOfTheWeek(parse(date, 'yyyy-MM-dd', new Date()))}
          {selection && (
            <Typography color="text.secondary" component="div" sx={{ fontWeight: 400, fontSize: 10, lineHeight: 1.2 }}>
              {picked ? '✓ 選択中' : 'クリックで選択'}
            </Typography>
          )}
        </TableCell>
      );
    })}
  </>
);
